module.exports = __webpack_public_path__ + "img/usb-manage.cde5c7e4.png";